import React from 'react'
import { Field, Form, reduxForm } from 'redux-form/dist/redux-form'
import InputField from '@modules/formFields/InputField'
import { withTranslation } from 'react-i18next'
import SelectField from '@modules/formFields/SelectField'
import { uploadImageComponent } from '@modules/formFields/uploadImageComponent'
import { getLanguageName } from '@modules/admin/speciality/actions'
import { SPECIALITY_TYPES } from '@modules/admin/speciality/constants'
import { displayLocaleName, languageCodes } from './specialty.utils'

const SpecialityForm = ({ handleSubmit, initialValues, t, submitting, error, submitFailed, onSubmit }) => {
  const { translations } = initialValues
  return (
    <Form className="md-form" onSubmit={handleSubmit(onSubmit)}>
      <div className="double-box">
        <div>
          <Field name="code" component={InputField} placeholder={t('Código')} label={t('Código')} />
          <Field
            type
            name="type"
            component={SelectField}
            options={SPECIALITY_TYPES}
            label={t('Tipo')}
            placeholder={t('Tipo')}
          />
          <div className="add-translation">{t('Traducciones')}</div>
          {translations.map((trans, index) => {
            const languageName = languageCodes.includes(trans.locale) ? displayLocaleName.of(trans.locale) : 'Unknown'
            return <Field name={`translations[${index}].name`} component={InputField} label={languageName} />
          })}
          {/*Implementar en un futuro errores de servidor*/}
          {/*{ error && submitFailed &&*/}
          {/*<div className="error">*/}
          {/*  {error?.translationArray &&  <div>{error.translationArray }</div>}*/}
          {/*</div>*/}
          {/*}*/}
        </div>
        <div>
          <Field name={'icon'} component={uploadImageComponent} label={t('Icono')} />
        </div>
      </div>

      <button type="submit" className="btn btn-primary" disabled={submitting}>
        Guardar
      </button>
    </Form>
  )
}
const validate = (values, props) => {
  const { t } = props
  const errors = {}
  if (!values.code) {
    errors.code = t('Campo requerido')
  }
  if (!values.type) {
    errors.type = t('Campo requerido')
  }

  /* if (!values.icon) {
    errors.icon = t('Campo requerido');
  } */

  // if (!values.translations) {
  //   errors._error = {...errors._error, translationArray: t('Faltan campos para rellenar en las traducciones')}
  // }

  let translationsArrayErrors = []
  values.translations &&
    values.translations.forEach((translation, index) => {
      let translationErrors = {}
      if (!translation.name) {
        translationErrors = { ...translationErrors, name: t('Campo requerido') }
        translationsArrayErrors[index] = translationErrors
      }
    })
  if (translationsArrayErrors.length) {
    errors.translations = {}
    errors.translations = translationsArrayErrors
  }
  return errors
}
const SpecialityReduxForm = reduxForm({
  form: 'speciality',
  validate,
})(SpecialityForm)
export default withTranslation()(SpecialityReduxForm)
